<template>
  <router-view :class="{'scroll-on-overflow': windowed}" />
</template>

<script setup>
import { onMounted, onUnmounted, ref } from "vue";

const windowed = ref(false);
const checkWindowed = () => {
  // console.log(window.innerWidth);
  // console.log(window.screen.width);
  // console.log(window.innerHeight);
  // console.log(window.screen.height);
  windowed.value = (window.innerWidth < window.screen.width || window.innerHeight < (window.screen.height - 200));
  }

onMounted(() => {
  checkWindowed();
  window.addEventListener('resize', checkWindowed);
});

onUnmounted(() => {
  window.removeEventListener('resize', checkWindowed);
})

</script>

<style lang="scss">
body {
  margin: .55rem;
  background-color: black;
  min-height: 98vh;
}

.scroll-on-overflow {
  scrollbar-color:  black white;
  overflow-y: scroll;
}

@font-face {
  font-family: Simply-Rounded;
  src: url('../src/assets/fonts/fonts/Simply\ Rounded.ttf');
}
@font-face {
  font-family: Typo-Rounded;
  src: url('../src/assets/fonts/fonts/Typo_Round_Regular_Demo.otf');
}
@font-face {
  font-family: DotOutline;
  src: url('../src/assets/fonts/fonts/DotOutline.ttf');
}
@font-face {
  font-family: Famirids;
  src: url('../src/assets/fonts/fonts/Famirids.ttf');
}
@font-face {
  font-family: righthand-bold-personal;
  src: url('../src/assets/fonts/fonts/righthand-bold-personal.ttf');
}
@font-face {
  font-family: VTKSSquares;
  src: url('../src/assets/fonts/fonts/VTKSSquares.ttf');
}
@font-face {
  font-family: Blox2;
  src: url('../src/assets/fonts/fonts/Blox2.ttf');
}

</style>
